import { Link, useLocation } from '@remix-run/react'
import { Menu } from 'lucide-react'
import { useState } from 'react'
import { Spacer } from './spacer'
import { Button } from './ui/button'
import {
	NavigationMenu,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
	navigationMenuTriggerStyle,
} from './ui/navigation-menu'
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from './ui/sheet'

export const MainNav = () => {
	const { pathname } = useLocation()
	const isActive = (path: string) => pathname.includes(path)
	const [isOpen, setIsOpen] = useState(false)

	return (
		<nav>
			{/* desktop */}
			<div className="hidden sm:block">
				<NavigationMenu>
					<NavigationMenuList>
						<NavigationMenuItem>
							<NavigationMenuLink
								asChild
								active={pathname === '/dashboard'}
								className={navigationMenuTriggerStyle()}
							>
								<Link to="/dashboard">Home</Link>
							</NavigationMenuLink>
						</NavigationMenuItem>
						<NavigationMenuItem>
							<NavigationMenuLink
								active={isActive('judges')}
								className={navigationMenuTriggerStyle()}
								asChild
							>
								<Link to="/judges">Judges</Link>
							</NavigationMenuLink>
						</NavigationMenuItem>
						<NavigationMenuItem>
							<NavigationMenuLink
								asChild
								active={isActive('documents')}
								className={navigationMenuTriggerStyle()}
							>
								<Link to="/documents">Documents</Link>
							</NavigationMenuLink>
						</NavigationMenuItem>
					</NavigationMenuList>
				</NavigationMenu>
			</div>
			{/* mobile */}
			<div className="sm:hidden">
				<Sheet open={isOpen} onOpenChange={setIsOpen}>
					<SheetTrigger asChild>
						<Button variant="ghost">
							<Menu />
						</Button>
					</SheetTrigger>
					<SheetContent side="left">
						<SheetHeader>
							<SheetTitle>Main Menu</SheetTitle>
						</SheetHeader>
						<Spacer size="3xs" />
						<Button
							className="w-full"
							asChild
							variant={isActive('dashboard') ? 'secondary' : 'ghost'}
							onClick={() => setIsOpen(false)}
						>
							<Link to="/dashboard">Home</Link>
						</Button>
						<Button
							className="w-full"
							asChild
							variant={isActive('judges') ? 'secondary' : 'ghost'}
							onClick={() => setIsOpen(false)}
						>
							<Link to="/judges">Judges</Link>
						</Button>
						<Button
							className="w-full"
							asChild
							variant={isActive('documents') ? 'secondary' : 'ghost'}
							onClick={() => setIsOpen(false)}
						>
							<Link to="/documents">Documents</Link>
						</Button>
					</SheetContent>
				</Sheet>
			</div>
		</nav>
	)
}
